import React, { FC, HTMLAttributes, useEffect, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./Snackbar.style";
import { Icon } from "../../core/Icon/Icon";
import { Typography } from "../../core";
import {
  TypographyColor,
  TypographyVariant,
} from "../../core/Typography/Typography";

interface ITabsProps {
  endIcon?: string | React.ReactNode;
  message: string;
  onClose?: () => void;
}

export const Snackbar: FC<ITabsProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { endIcon, className, message, onClose, ...otherProps } = props;

  const [open, setOpen] = useState(true);

  useEffect(() => {
    const timeoutHide = setTimeout(() => {
      setOpen(false);
    }, 3000);
    return () => clearTimeout(timeoutHide);
  }, []);

  useEffect(() => {
    // close snackbar after fade out
    if (open) return;
    const timeoutClose = setTimeout(() => {
      onClose?.();
    }, 300);
    return () => clearTimeout(timeoutClose);
  }, [onClose, open]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      {...otherProps}
      className={clsx(classes.root, className, !open && classes.hideFade)}
    >
      <div className={clsx(classes.content)}>
        <Typography
          variant={TypographyVariant.BodyB5Bold}
          color={TypographyColor.Text1}
          lines={2}
        >
          {message}
        </Typography>
      </div>
      {typeof endIcon === "string" ? (
        <Icon
          name="icon-bold-close"
          className={classes.icon}
          onClick={() => setOpen(false)}
        />
      ) : (
        endIcon
      )}
    </div>
  );
};
